import { useState, useCallback, memo } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar } from "@mui/material";
// cmps
import GraphDeviceNode from "./GraphDeviceNode";
// types
import type { CustomForceGraphNode } from "../../../types/misc";

type Props = Readonly<{
	nodes: ReadonlyArray<CustomForceGraphNode>;
	highlightNodeIds: ReadonlySet<string>;
	nodePositions: ReadonlyMap<string, { x: number; y: number }>;
}>;

const GraphDeviceNodes = ({ nodes, highlightNodeIds, nodePositions }: Props) => {
	const { t } = useTranslation();

	const [showCopySnackbar, setShowCopySnackbar] = useState(false);

	const handleCopyMacIdClick = useCallback(async (nodeId: string) => {
		try {
			await navigator.clipboard.writeText(nodeId);
			setShowCopySnackbar(true);
		} catch (error) {
			console.warn(error);
		}
	}, []);

	const handleClose = useCallback(() => {
		setShowCopySnackbar(false);
	}, []);

	return (
		<>
			{nodes.map((node) => {
				const pos = nodePositions.get(node.id);
				return (pos === undefined) ? null :
					<GraphDeviceNode
						key={node.id}
						node={node}
						posX={pos.x}
						posY={pos.y}
						isHighlighted={highlightNodeIds.has(node.id)}
						onCopyMacIdClick={handleCopyMacIdClick}
					/>;
			})}
			<Snackbar
				open={showCopySnackbar}
				message={t("gateway.nodeCopyMsg")}
				autoHideDuration={3000}
				onClose={handleClose}
			/>
		</>
	);
};

export default memo(GraphDeviceNodes);
